import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import Navigation from './components/Navigation';
import ScrollToTop from './components/ScrollToTop';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import DawgLegalPage from './pages/DawgLegalPage';
import dawgPrivacyContent from './content/dawg/privacyContent';
import dawgTermsContent from './content/dawg/termsContent';
import dawgSupportContent from './content/dawg/supportContent';
import mioPrivacyContent from './content/mio/privacyContent';
import mioTermsContent from './content/mio/termsContent';
import mioSupportContent from './content/mio/supportContent';
import trueformPrivacyContent from './content/trueform/privacyContent';
import trueformTermsContent from './content/trueform/termsContent';
import trueformSupportContent from './content/trueform/supportContent';
import swingsightPrivacyContent from './content/swingsight/privacyContent';
import swingsightTermsContent from './content/swingsight/termsContent';
import swingsightSupportContent from './content/swingsight/supportContent';

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <div className="App">
        <Navigation />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route
              path="/dawg/privacy"
              element={
                <DawgLegalPage
                  appName="DAWG"
                  pageLabel="Privacy Policy"
                  content={dawgPrivacyContent}
                />
              }
            />
            <Route
              path="/dawg/terms"
              element={
                <DawgLegalPage
                  appName="DAWG"
                  pageLabel="Terms of Use"
                  content={dawgTermsContent}
                />
              }
            />
            <Route
              path="/dawg/support"
              element={
                <DawgLegalPage
                  appName="DAWG"
                  pageLabel="Support"
                  content={dawgSupportContent}
                />
              }
            />
            <Route
              path="/mio/privacy"
              element={
                <DawgLegalPage
                  appName="Mio"
                  pageLabel="Privacy Policy"
                  content={mioPrivacyContent}
                />
              }
            />
            <Route
              path="/mio/terms"
              element={
                <DawgLegalPage
                  appName="Mio"
                  pageLabel="Terms of Use"
                  content={mioTermsContent}
                />
              }
            />
            <Route
              path="/mio/support"
              element={
                <DawgLegalPage
                  appName="Mio"
                  pageLabel="Support"
                  content={mioSupportContent}
                />
              }
            />
            <Route
              path="/trueform/privacy"
              element={
                <DawgLegalPage
                  appName="Trueform"
                  pageLabel="Privacy Policy"
                  content={trueformPrivacyContent}
                />
              }
            />
            <Route
              path="/trueform/terms"
              element={
                <DawgLegalPage
                  appName="Trueform"
                  pageLabel="Terms of Use"
                  content={trueformTermsContent}
                />
              }
            />
            <Route
              path="/trueform/support"
              element={
                <DawgLegalPage
                  appName="Trueform"
                  pageLabel="Support"
                  content={trueformSupportContent}
                />
              }
            />
            <Route
              path="/swingsight/privacy"
              element={
                <DawgLegalPage
                  appName="SwingSight"
                  pageLabel="Privacy Policy"
                  content={swingsightPrivacyContent}
                />
              }
            />
            <Route
              path="/swingsight/terms"
              element={
                <DawgLegalPage
                  appName="SwingSight"
                  pageLabel="Terms of Use"
                  content={swingsightTermsContent}
                />
              }
            />
            <Route
              path="/swingsight/support"
              element={
                <DawgLegalPage
                  appName="SwingSight"
                  pageLabel="Support"
                  content={swingsightSupportContent}
                />
              }
            />
          </Routes>
        </main>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
